import * as React from 'react'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { ConsentRedirectDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

type State = 'loading' | 'opening' | 'error'

const ConsentRedirectPage = () => {
  const { consentId } = useParams<{ consentId: string }>()
  const [state, setState] = useState<State>('loading')
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const consentIdNum = consentId ? parseInt(consentId, 10) : undefined
  const { data, error } = useQuery(ConsentRedirectDocument, {
    variables: { id: consentIdNum ?? 0 },
    skip: !consentIdNum || isNaN(consentIdNum),
  })

  useEffect(() => {
    if (!consentId || !consentIdNum || isNaN(consentIdNum)) {
      setState('error')
      setErrorMessage(i18n.t('salary_advance.consent_redirect.invalid_consent'))
      return
    }

    if (error) {
      setState('error')
      setErrorMessage(i18n.t('salary_advance.consent_redirect.error'))
      return
    }

    const consent = data?.banking?.consent
    const url = consent?.consentUrl

    if (!data) return

    if (!url || typeof url !== 'string') {
      setState('error')
      setErrorMessage(i18n.t('salary_advance.consent_redirect.not_found'))
      return
    }

    setState('opening')
    window.open(url)
  }, [consentId, consentIdNum, data, error])

  if (state === 'error') {
    return (
      <Box padding="s24">
        <Text size="200" color="grey800">
          {errorMessage}
        </Text>
      </Box>
    )
  }

  return (
    <Box padding="s24">
      <Text size="200" color="grey800">
        {state === 'loading'
          ? i18n.t('salary_advance.consent_redirect.loading')
          : i18n.t('salary_advance.consent_redirect.opening')}
      </Text>
    </Box>
  )
}

export default ConsentRedirectPage
